













































import { Vue, Component } from "vue-property-decorator";
import { WareService } from "@/modules/ware/ware.service";
import { Ware } from "@/modules/ware/ware.interface";
import DetectionTable from "@/modules/ware/WareDetectionTable.vue";
import { useList } from "@/uses/list.use";
import { useInputDebounce } from "@/uses/inputDebounce.use";
@Component({
  components: {
    DetectionTable
  },
  metaInfo: {
    title: "APK检测历史版本"
  }
})
export default class ApkDetail extends Vue {
  apk: Ware | null = null;
  search = "";

  get id() {
    return this.$route.params.id;
  }
  async created() {
    this.apk = await WareService.getWare(this.id);
  }
  goBack() {
    this.$router.push("/ware/developer");
  }

  setup(_, context) {
    const apk = useList([]);
    const search = useInputDebounce(text => {
      apk.search(text, ["developerID"]);
    });
    return {
      search,
      apk
    };
  }
}
